/**
 * 合併 v2 會員分段 API 回應
 */
export function mergeMemberV2Data(base = {}, summary = {}, profile = {}) {
  return {
    ...base,
    ...summary,
    ...profile,
    tags: base.tags || [],
    level: {
      ...(base.level || {}),
      ...(summary.level || {}),
      ...(profile.level || {}),
    },
  }
}

/**
 * 載入 v2 會員基本 + 摘要（櫃檯流程用）
 */
export async function fetchMemberShortWithSummary(store, memberId) {
  const [base, summary] = await Promise.all([
    store.dispatch('member/fetchSingleShort', { memberId }),
    store.dispatch('member/fetchMemberSummary', { memberId }),
  ])
  return mergeMemberV2Data(base, summary)
}

/**
 * 是否為 schedule-check-in 櫃檯流程
 */
export function isScheduleCheckInRoute(route) {
  return route?.name === 'schedule-check-in' || route?.query?.from === 'schedule-check-in'
}

/**
 * 是否為住宿流程（訂單詳情等）需 v2 輕量載入會員
 */
export function isHotelLightMemberRoute(route) {
  return route?.name === 'hotelViewOrder'
}

/**
 * 是否應使用 v2 分段會員 API（short / summary / profile lazy）
 */
export function shouldUseLightMemberFetch(route) {
  return isScheduleCheckInRoute(route) || isHotelLightMemberRoute(route)
}
